module.exports = __webpack_public_path__ + "img/io.84de1d2.svg";